/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserLvl } from './UserLvl';
import {
    UserLvlFromJSON,
    UserLvlFromJSONTyped,
    UserLvlToJSON,
    UserLvlToJSONTyped,
} from './UserLvl';

/**
 * 
 * @export
 * @interface GetUsersCsvResponse
 */
export interface GetUsersCsvResponse {
    /**
     * 
     * @type {Array<UserLvl>}
     * @memberof GetUsersCsvResponse
     */
    users: Array<UserLvl>;
}

/**
 * Check if a given object implements the GetUsersCsvResponse interface.
 */
export function instanceOfGetUsersCsvResponse(value: object): value is GetUsersCsvResponse {
    if (!('users' in value) || value['users'] === undefined) return false;
    return true;
}

export function GetUsersCsvResponseFromJSON(json: any): GetUsersCsvResponse {
    return GetUsersCsvResponseFromJSONTyped(json, false);
}

export function GetUsersCsvResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUsersCsvResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'users': ((json['users'] as Array<any>).map(UserLvlFromJSON)),
    };
}

export function GetUsersCsvResponseToJSON(json: any): GetUsersCsvResponse {
    return GetUsersCsvResponseToJSONTyped(json, false);
}

export function GetUsersCsvResponseToJSONTyped(value?: GetUsersCsvResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'users': ((value['users'] as Array<any>).map(UserLvlToJSON)),
    };
}

